module.exports = __webpack_public_path__ + "img/WarningIcon.47d7fe37.svg";